import classNames from 'classnames'
import React from 'react'
import Spinner from '~/components/Spinner'
import styles from './Balance.pcss'

interface Props {
	hidden: boolean
	value?: string
}

export function Balance({ hidden, value }: Props): JSX.Element {
	let balance: React.ReactNode

	if (!value) {
		balance = (
			<Spinner
				className={classNames(styles.spinner, hidden && styles.hidden)}
			/>
		)
	} else {
		balance = `${value} SIS`
	}

	return (
		<div className={classNames(styles.container, hidden && styles.hidden)}>
			Balance: {balance}
		</div>
	)
}
